import { JobTitlesMarketing, MainPropertyTypeEnum, OtherJobTitles, WhenPlanToUseSoftware } from "@/dto";

export const JOB_TITLE_MARKETING_TRANSLATIONS = {
  [JobTitlesMarketing.HOA_MEMBER_OR_MANAGER]: "I work with a community association",
  [JobTitlesMarketing.PROPERTY_MANAGER]: "I manage the properties",
  [JobTitlesMarketing.LANDLORD]: "I own and manage the properties",
  [JobTitlesMarketing.OTHER]: "Other",
  [JobTitlesMarketing.MANAGEMENT_COMPANY_OWNER]: "I own or run a property management company",
  [JobTitlesMarketing.PROPERTY_OWNER]: "I own the properties"
};

export const OTHER_JOB_TITLE_TRANSLATIONS = {
  [OtherJobTitles.TENANT]: "Tenant",
  [OtherJobTitles.ATTORNEY]: "Attorney",
  [OtherJobTitles.ACCOUNTANT]: "Accountant",
  [OtherJobTitles.OTHER]: "Other"
};

export const MAIN_PROPERTY_TYPE_TRANSLATIONS = {
  [MainPropertyTypeEnum.RESIDENTIAL]: "Residential",
  [MainPropertyTypeEnum.COMMERCIAL]: "Commercial",
  [MainPropertyTypeEnum.RESIDENTIAL_COMMERCIAL]: "Residential & Commercial",
  [MainPropertyTypeEnum.COMMUNITY_ASSOCIATIONS]: "Community Associations",
  [MainPropertyTypeEnum.AFFORDABLE_HOUSING]: "Affordable Housing",
  [MainPropertyTypeEnum.STORAGE]: "Storage",
  [MainPropertyTypeEnum.SHORT_TERM_RENTALS]: "Short Term Rentals",
  [MainPropertyTypeEnum.OTHER]: "Other"
};

export const WHEN_PLAN_TO_USE_SOFTWARE_TRANSLATIONS = {
  [WhenPlanToUseSoftware.ASAP]: "ASAP",
  [WhenPlanToUseSoftware.ONE_TO_THREE_MONTHS]: "1-3 Months",
  [WhenPlanToUseSoftware.THREE_TO_SIX_MONTHS]: "3-6 Months",
  [WhenPlanToUseSoftware.SIX_MONTHS_PLUS]: "6 Months +",
  [WhenPlanToUseSoftware.JUST_RESEARCHING]: "Just Researching"
};
